function initSwiper() {
	let swiperVideoRevies = new Swiper(
		'.section-video-reviews__swiper-container',
		{
			slidesPerView: 2,
			spaceBetween: 10,
			loop: true,
			lazy: true,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
			breakpoints: {
				730: {
					slidesPerView: 3,
					spaceBetween: 10,
					slidesPerGroup: 1,
				},
				991: {
					slidesPerView: 4,
					spaceBetween: 10,
					slidesPerGroup: 1,
				},
			},
		}
	)

	let swiperImgCatalog = new Swiper('.section-catalog__swiper-container', {
		slidesPerView: 1,
		spaceBetween: 10,
		loop: true,
		lazy: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.Swiper-button-next-video-reviews',
			prevEl: '.Swiper-button-prev-video-reviews',
		},
		breakpoints: {
			1024: {
				slidesPerView: 1,
				spaceBetween: 10,
			},
		},
	})
	let swiperLink = new Swiper('.section-directory__swiper-container', {
		// slidesPerView: 3,
		slidesPerView: 'auto',
		spaceBetween: 10,
		// preventClicks: false,
		clickable: true,
		loop: true,
		lazy: true,
		navigation: {
			nextEl: '.Swiper-button-next-video-reviews',
			prevEl: '.Swiper-button-prev-video-reviews',
		},
		breakpoints: {
			1024: {
				// spaceBetween: 10,
			},
		},
	})
	let swiperPopUpMaster = new Swiper(
		'.popup-selection-master__swiper-container, .popup-interior-door__swiper-container',
		{
			slidesPerView: 1,
			observer: true,
			autoHeight: true,
			simulateTouch: false,
			lazy: true,
			navigation: {
				nextEl: '.popup-swiper-btn-next-js',
				prevEl: '.popup-swiper-btn-prev-js',
			},
		}
	)
	let swiperPopUpInformation = new Swiper(
		'.popup-information__swiper-container',
		{
			slidesPerView: 1,
			observer: true,
			// autoHeight: true,
			simulateTouch: true,
			lazy: true,
			navigation: {
				nextEl: '.popup-swiper-btn-next-js',
				prevEl: '.popup-swiper-btn-prev-js',
			},
		}
	)

	let swiperImgCardElementary = new Swiper(
		'.item-Card-elementary__swiper-container',
		{
			slidesPerView: 1,
			spaceBetween: 10,
			loop: true,
			lazy: true,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
		}
	)

	let swiperSectionProducts = new Swiper(
		'.section-products__swiper-container',
		{
			slidesPerView: 2,
			spaceBetween: 12,
			setWrapperSize: true,
			loop: false,
			lazy: true,
			autoHeight: true,
			observer: true,
			observeParents: true,
			simulateTouch: false,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
			breakpoints: {
				1400: {
					slidesPerView: 3,
					spaceBetween: 20,
					setWrapperSize: true,
				},
			},
		}
	)
	let swiperSectionRelatedProducts = new Swiper(
		'.section-related-products__swiper-container',
		{
			slidesPerView: 1,
			spaceBetween: 10,
			loop: true,
			// autoHeight: true,
			observer: true,
			lazy: true,
			observeParents: true,
			simulateTouch: false,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
			breakpoints: {
				1250: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
				850: {
					slidesPerView: 3,
					spaceBetween: 12,
				},
				550: {
					slidesPerView: 2,
					spaceBetween: 12,
				},
			},
		}
	)
	let swiperPhotoBattle = new Swiper('.item-photo-battle__sliders', {
		slidesPerView: 1.58,
		spaceBetween: 20,
		// loop: true,
		lazy: true,
		centeredSlides: true,
		initialSlide: 1,
		watchOverflow: true,
		// freeMode: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		on: {
			init: function (instance) {
				// if (instance.slides.length === 1) {
				// 	console.log(instance.pagination);
				// 	instance.pagination.el.remove()
				// }
				$.extend(true, $.fancybox.defaults, {
					afterClose: function (_, e) {
						try {
							const sliderView = e.$thumb[0].closest('[data-slider]')
							const sliderModel = swiperPhotoBattle
								.filter(
									s => s.$el[0].dataset.slider === sliderView.dataset.slider
								)
								.pop()
							sliderModel.slideTo(e.index, 0)
						} catch {}
					},
				})
			},
		},
	})
	// New code
	let swiperNewLink = new Swiper('.section-directory__directory-slider', {
		// slidesPerView: 3,
		slidesPerView: 'auto',
		spaceBetween: 10,
		// preventClicks: false,
		clickable: true,
		loop: true,
		// lazy: true,
		navigation: {
			nextEl: '.Swiper-button-next-video-reviews',
			prevEl: '.Swiper-button-prev-video-reviews',
		},
		// breakpoints: {
		// 	1024: {
		// 		// spaceBetween: 10,
		// 	},
		// },
	})
	// let swiperComparesCards = new Swiper('.compares-cards__swiper-container', {
	//   slidesPerView: 4,
	//   spaceBetween: 10,
	//   slidesPerColumn: 2,
	//   slidesPerColumnFill: 'row',
	//   // autoHeight: true,
	//   observer: true,
	//   observeParents: true,
	//   simulateTouch: false,

	//   scrollbar: {
	//     el: '.swiper-scrollbar',
	//     hide: false,
	//     draggable: true,
	//   },
	//   navigation: {
	//     nextEl: '.Swiper-button-next-video-reviews',
	//     prevEl: '.Swiper-button-prev-video-reviews',
	//   },
	//   breakpoints: {
	//     1340: {
	//       slidesPerView: 3,
	//       spaceBetween: 10,
	//       slidesPerColumn: 2,
	//       slidesPerColumnFill: 'row',
	//     },
	//     1080: {
	//       slidesPerView: 3,
	//       spaceBetween: 0,
	//       slidesPerColumn: 2,
	//       slidesPerColumnFill: 'row',
	//     },
	//     867: {
	//       slidesPerView: 2,
	//       spaceBetween: 0,
	//       slidesPerColumn: 2,
	//       slidesPerColumnFill: 'row',
	//     },
	//     200: {
	//       slidesPerView: 1,
	//       spaceBetween: 0,
	//       slidesPerColumn: 2,
	//       slidesPerColumnFill: 'row',
	//       pagination: {
	//         el: '.swiper-pagination',
	//         type: 'fraction',
	//       },
	//     },
	//   },
	// })

	new Swiper('.live-photos__swiper', {
		slidesPerView: 5,
		spaceBetween: 5,
		clickable: true,
		navigation: false,
	})

	//// section news

	let newsSliderBig = new Swiper('.news-slider--big', {
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		simulateTouch: true,
		grab: true,
		zoom: {
			maxRatio: 6,
			minRation: 1,
		},
	})

	let newsSlider = new Swiper('.news-slider', {
		slidesPerView: 6,
		spaceBetween: 10,
		observer: true,
		observeParents: true,
		simulateTouch: true,
		grab: true,
		breakpoints: {
			200: {
				slidesPerView: 1,
			},
			430: {
				slidesPerView: 2,
			},
			660: {
				slidesPerView: 3,
			},
			890: {
				slidesPerView: 4,
			},
			1120: {
				slidesPerView: 5,
			},
			1350: {
				slidesPerView: 6,
			},
		},
	})

	// const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', {
	// 	direction: 'horizontal',
	// 	slidesPerView: 'auto',
	// 	spaceBetween: 10,
	// 	mousewheel: true,
	// 	navigation: {
	// 		nextEl: '.slider__next',
	// 		prevEl: '.slider__prev',
	// 	},
	// 	grabCursor: true,
	// })

	let schoolReviewsSwiper = new Swiper('.school-reviews-swiper', {
		slidesPerView: 2,
		spaceBetween: 10,
		observer: true,
		observeParents: true,
		grab: true,
		loop: true,
		simulateTouch: true,
		clickable: true,
		breakpoints: {
			200: {
				slidesPerView: 1,
			},
			630: {
				slidesPerView: 2,
			},
		},
	})

	const schoolSlider = new Swiper('.school-about-swiper', {
		direction: 'horizontal',
		slidesPerView: 5,
		spaceBetween: 10,
		mousewheel: false,
		simulateTouch: true,
		clickable: true,
		grab: true,
		loop: false,
		slideToClickedSlide: true,

		breakpoints: {
			250: {
				slidesPerView: 2,
			},
			500: {
				slidesPerView: 2,
			},
			750: {
				slidesPerView: 3,
			},
			1000: {
				slidesPerView: 4,
			},
			1250: {
				slidesPerView: 5,
			},
		},
		on: {
			click: function (swiper, e) {
				swiper.slides.forEach(slide => {
					slide.classList.remove('active')
				})

				const clickedIndex = swiper.clickedIndex

				swiper.slides[clickedIndex].classList.add('active')

				swiper.slideTo(clickedIndex)
			},
		},
	})

	const sliderThumbs = new Swiper('.swiper-card-horizontal', {
		slidesPerView: 3,
		spaceBetween: 30,
		mousewheel: true,
		slideToClickedSlide: true,
		grab: true,
		// loop: true,
		navigation: {
			nextEl: '.slider__next-horizontal',
			prevEl: '.slider__prev-horizontal',
		},
	})

	const sliderImages = new Swiper('.swiper-card-vertical', {
		direction: 'vertical',
		slidesPerView: 3,
		spaceBetween: 10,
		mousewheel: true,
		slideToClickedSlide: true,
		grab: true,
		// loop: true,
		navigation: {
			nextEl: '.slider__next-vertical',
			prevEl: '.slider__prev-vertical',
		},

		breakpoints: {
			0: {
				direction: 'horizontal',
			},
			768: {
				direction: 'vertical',
			},
		},
	})
}

const slides = document.querySelectorAll('.swiper-slide-horizontal')

slides.forEach((slide, index) => {
	slide.addEventListener('click', () => {
		slides.forEach(s => {
			s.classList.remove('swiper-slide-active')
		})
		slide.classList.add('swiper-slide-active')
		slider.slideTo(index)
	})
})

const slidesV = document.querySelectorAll('.swiper-slide-vertical')

slidesV.forEach((slide, index) => {
	slide.addEventListener('click', () => {
		slidesV.forEach(s => {
			s.classList.remove('swiper-slide-active')
		})
		slide.classList.add('swiper-slide-active')
		slider.slideTo(index)
	})
})

function updateSwiperWidth() {
	const slides = document.querySelectorAll('.swiper-slide-horizontal')

	if (slides.length == 1) {
		const swiper = document.querySelector('.swiper-card-horizontal')
		const slide = document.querySelector(
			'.swiper-slide.swiper-slide-horizontal'
		)
		const cont = document.querySelector('.cont')

		if (slide) {
			slide.classList.add('test-1')
			slide.style.width = '100px'
		}
		if (cont) {
			cont.style.width = '121px'
		}
	}
	if (slides.length == 2) {
		const swiper = document.querySelector('.swiper-card-horizontal')
		const slides = document.querySelectorAll(
			'.swiper-slide.swiper-slide-horizontal'
		)
		const cont = document.querySelector('.cont')
		slides.forEach(slide => {
			slide.classList.add('test-2')
		})
		if (cont) {
			cont.style.width = '340px'
		}
	}
}

document.addEventListener('DOMContentLoaded', updateSwiperWidth)
